import { BoxTitles } from "./BoxTitles";

export const BoxCategories = [
  {
    label: "Públicos",
    boxes: [
      { label: BoxTitles.FullAudience, type: "FullAudience" },
      {
        label: BoxTitles.SavedAudience,
        type: "SavedAudience",
      },
      {
        label: BoxTitles.ImportedAudience,
        type: "ImportedAudience",
      },
      {
        label: BoxTitles.EventSource,
        type: "EventSource",
      },
      {
        label: BoxTitles.BroadcastAudience,
        type: "BroadcastAudience",
      },
    ],
  },

  {
    label: "Condicionais",
    boxes: [
      {
        label: BoxTitles.DayOfWeekConditional,
        type: "DayOfWeekConditional",
      },
      {
        label: BoxTitles.DayOfMonthConditional,
        type: "DayOfMonthConditional",
      },
      {
        label: BoxTitles.SpecificDayConditional,
        type: "SpecificDayConditional",
      },
      {
        label: BoxTitles.SpecificClimateConditional,
        type: "SpecificClimateConditional",
      },
    ],
  },
  {
    label: "Ações",
    boxes: [
      {
        label: BoxTitles.CreativeGroupAction,
        type: "CreativeGroupAction",
        isGroup: true,
      },
      { label: BoxTitles.SmsCreativeAction, type: "SmsCreativeAction" },
      {
        label: BoxTitles.PushCreativeAction,
        type: "PushCreativeAction",
      },
      {
        label: BoxTitles.EmailCreativeAction,
        type: "EmailCreativeAction",
      },
      {
        label: BoxTitles.WhatsAppCreativeAction,
        type: "WhatsAppCreativeAction",
        godmode: true,
      },
    ],
  },
];
